import { supabase } from '@/integrations/supabase/client';
import type { ErrorReportContext, ErrorReportInput } from '@/lib/errorReport';

/**
 * Send a report to the team's queue.
 *
 * Returns `false` rather than throwing: the dialog's job is to keep the text
 * and offer Copy / email when this path is unavailable, so a failed request is
 * a state the caller renders, not an exception that loses what the person
 * wrote.
 */
export async function submitErrorReport(
  context: ErrorReportContext,
  input: ErrorReportInput,
): Promise<boolean> {
  try {
    const { error } = await supabase.functions.invoke('report-client-error', {
      body: {
        reference: context.reference,
        route: context.route,
        surface: context.surface,
        summary: context.summary,
        message: input.whatHappened.trim().slice(0, 4000),
        expected: input.expected?.trim().slice(0, 4000) || null,
      },
    });
    return !error;
  } catch {
    return false;
  }
}
